import React, { useState } from "react";
import { Link } from "react-router-dom";
import VisitorNavbar from "../component/VisitorNavbar";
import Footer from "../component/Footer";
import axios from "axios";
import { baseurl } from "../Baseurl";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const CustomerForgetPassword = () => {

  const [email, setEmail] = useState("");
  const [message, setMessage] = useState(""); // success or error message
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!email) {
      setMessage("Please enter a valid email address.");
      return;
    }
  
    setLoading(true);
    setMessage("");
  
    // 🔍 Log the data being sent
    console.log("Sending forgot password request with email:", email);
  
    try {
      const response = await axios.post(`${baseurl}userForgotPassword`, { email });

      console.log("response",response);
  
      if (response.data.success) {
  toast.success("Reset link has been sent to your email successfully", {
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored"
  });
  setMessage("");
} else {
  setMessage(response.data.error || "Something went wrong.");
}

    } catch (error) {
      console.error("Forgot Password Error:", error);
      setMessage("Server error. Please try again later.");
    }
  
    setLoading(false);
  };



  return (
    <>
    <VisitorNavbar/>
      <div>
        <section className="mb-5">
          <div className="container">
            <div className="row my-3 justify-content-center">
              <div className="col-md-5">
                <div className="reviewcls">
                  <h4 className="review-form-heading">Forgot Password</h4>
                  <p className="payttl">
                    Enter your email address below to receive a password reset link.
                  </p>
                  <hr />
                  <form className="contact-form text-start" onSubmit={handleSubmit}>
                    <div className="row g-2">
                      {/* Email Address */}
                      <div className="col-12">
                        <label htmlFor="email" className="form-label">
                          Email Address <span className="text-danger">*</span>
                        </label>
                        <input
                          type="email"
                          id="email"
                          className="form-control"
                          placeholder="Enter your email address"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                        />
                      </div>
                    </div>

                    <div className="mt-3">
  <button type="submit" className="btn submitbtnn w-100" disabled={loading}>
    {loading ? (
      <>
        <span
          className="spinner-border spinner-border-sm me-2"
          role="status"
          aria-hidden="true"
        ></span>
        Sending...
      </>
    ) : (
      "Submit"
    )}
  </button>
</div>

                  </form>

                  <div className="mt-3 text-center">
                    <p>
                      Remembered your password?{" "}
                      <Link to="/customer/login" className="text-primary">
                        Login
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
<ToastContainer />
<Footer/>

    </>
  );
};

export default CustomerForgetPassword;
